import { render, staticRenderFns } from "./PayrollAccounting.vue?vue&type=template&id=84c1dc6a&scoped=true&"
import script from "./PayrollAccounting.vue?vue&type=script&lang=js&"
export * from "./PayrollAccounting.vue?vue&type=script&lang=js&"
import style0 from "./PayrollAccounting.vue?vue&type=style&index=0&id=84c1dc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c1dc6a",
  null
  
)

export default component.exports